import React from "react";
import AssignOrder from "../../components/AssignOrder";
import { ORDER_TYPE } from "../../enums/order.enum";

const AssignMedicinesOrder = () => {
  return <AssignOrder orderType={ORDER_TYPE.MEDICINES} />;
};

export default AssignMedicinesOrder;
